import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const RoleBasedRedirect: React.FC = () => {
  const { user, isLoading } = useAuth();

  // Show loading while checking auth
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-dental-600"></div>
      </div>
    );
  }

  // Redirect based on user role
  if (user?.role === 'patient') {
    return <Navigate to="/appointments" replace />;
  }

  // Default redirect for staff
  return <Navigate to="/dashboard" replace />;
};

export default RoleBasedRedirect;